<public-header />
<main class="min-h-[100lvh] mt-16 bg-slate-50">
   <router-outlet></router-outlet>
</main>
<public-footer />